import { useRouter } from "found";
import React from "react";
import { WebSettingsOrganizationMembers } from "../../components/web-settings/web-settings-organization-members";

const OrganizationMembers = () => {
  const { match } = useRouter();

  return <WebSettingsOrganizationMembers match={match} />;
};

export default OrganizationMembers;
